interface Config {
  env: 'dev' | 'qa' | 'prod';
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
    redirectUri: string;
  };
  socket: {
    url: string;
  };
  api: {
    url: string;
  };
  sentry: {
    dsn: string;
  };
  version: string;
  encryptionKey: string;
  flightEncryptionKey: string;
}

export const getConfig = (): Config => ({
  env: (process.env.REACT_APP_NODE_ENV ?? 'dev') as 'dev' | 'qa' | 'prod',
  auth0: {
    domain: process.env.REACT_APP_AUTH_DOMAIN?.replace('https://', '') ?? '',
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID ?? '',
    audience: process.env.REACT_APP_AUTH_AUDIENCE ?? '',
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI ?? '',
  },
  socket: {
    url: process.env.REACT_APP_SERVER_ROOT_URL ?? '',
  },
  api: {
    url: process.env.REACT_APP_API_URL ?? '',
  },
  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN ?? '',
  },
  version: process.env.REACT_APP_VERSION || 'unknown',
  encryptionKey: process.env.REACT_APP_ENCRYPTION_KEY ?? '',
  flightEncryptionKey: process.env.REACT_APP_FLIGHT_ENCRYPTION_KEY ?? '',
});
